import { render } from "./NewTDAAddParticipantForm.vue?vue&type=template&id=c5e26e34&scoped=true"
import script from "./NewTDAAddParticipantForm.vue?vue&type=script&lang=js"
export * from "./NewTDAAddParticipantForm.vue?vue&type=script&lang=js"

import "./NewTDAAddParticipantForm.vue?vue&type=style&index=0&id=c5e26e34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e26e34"]])

export default __exports__